import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContextHolder, FronteggAuthService } from '@frontegg/angular';
import { filter, Subject, take } from 'rxjs';
import { ApiService } from '../../core/services/api/api.service';
import { getApiUrl, getFrontEndApi, getShopLogoUrl } from '../../core/services/utils/util.service';
import { UserService } from '../../services/user/user.service';

@Component({
  selector: 'integrations-auth',
  templateUrl: './integrations-auth.component.html',
  styleUrls: ['./integrations-auth.component.scss'],
  standalone: false,
})
export class IntegrationsAuthComponent implements OnInit, OnDestroy {
  destroy$ = new Subject();
  API_URL = getApiUrl();
  getShopLogoUrl = getShopLogoUrl;
  userShops;

  afterShopClick = false;
  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private userService: UserService,
    private fronteggAuthService: FronteggAuthService,
    private cd: ChangeDetectorRef,
  ) {}
  ngOnDestroy(): void {
    this.destroy$.next(true);
  }
  onShopClick(shopId: number) {
    this.afterShopClick = true;
    const tenantId = `${shopId}`;
    // ApiService takes its token from this same user$ and subscribed first, so oauth/url goes out as the picked shop.
    this.fronteggAuthService.user$
      .pipe(
        filter((user) => user?.tenantId === tenantId),
        take(1),
      )
      .subscribe(() => this.redirectToOAuth());
    ContextHolder.setAccessToken(this.apiService.jwtToken);
    this.fronteggAuthService.switchTenant({
      tenantId,
      silentReload: true,
      callback: (switched) => {
        if (!switched) {
          window.open(getFrontEndApi(), '_self');
        }
      },
    });
  }

  ngOnInit(): void {
    this.userService.currentMeUser$.subscribe((user) => {
      this.userShops = user?.shops || [];
      this.cd.detectChanges();
    });
  }

  private redirectToOAuth() {
    const params = this.route.snapshot.queryParams;
    this.apiService.get('integrations/oauth/url', { params }).subscribe(
      ({ url }) => {
        window.open(url, '_self');
      },
      (err) => {
        window.open(getFrontEndApi(), '_self');
      },
    );
  }
}
